import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEngageLaserweeder = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "flare",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_4",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_4)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "flare_2",
				d: "M1 13V11H7V13H1ZM7.75 9.15L5.65 7.05L7.05 5.65L9.15 7.75L7.75 9.15ZM11 7V1H13V7H11ZM16.25 9.15L14.85 7.75L16.95 5.65L18.35 7.05L16.25 9.15ZM17 13V11H23V13H17ZM9.875 14.125C9.29167 13.5417 9 12.8333 9 12C9 11.1667 9.29167 10.4583 9.875 9.875C10.4583 9.29167 11.1667 9 12 9C12.8333 9 13.5417 9.29167 14.125 9.875C14.7083 10.4583 15 11.1667 15 12C15 12.8333 14.7083 13.5417 14.125 14.125C13.5417 14.7083 12.8333 15 12 15C11.1667 15 10.4583 14.7083 9.875 14.125ZM16.95 18.35L14.85 16.25L16.25 14.85L18.35 16.95L16.95 18.35ZM7.05 18.35L5.65 16.95L7.75 14.85L9.15 16.25L7.05 18.35ZM11 23V17H13V23H11Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgEngageLaserweeder;
